// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-drawer {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    height: 100vh;
    width: 50%;
    background: white;
    box-shadow: 0 2px 8px rgba(0,0,0,0.26);
}`, "",{"version":3,"sources":["webpack://./src/shared/components/Navigation/SideDrawer.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,OAAO;IACP,MAAM;IACN,YAAY;IACZ,aAAa;IACb,UAAU;IACV,iBAAiB;IACjB,sCAAsC;AAC1C","sourcesContent":[".side-drawer {\n    position: fixed;\n    left: 0;\n    top: 0;\n    z-index: 100;\n    height: 100vh;\n    width: 50%;\n    background: white;\n    box-shadow: 0 2px 8px rgba(0,0,0,0.26);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
